import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { GroupRepository } from '@domain/group/group.repository';
import { Group, GroupCreateData } from '@domain/group/group';
import { GroupResponseDto } from '../dtos/group/group.response.dto';
import { GroupMapper } from '../mappers/group.mapper';

@Injectable()
export class GroupHttpRepository extends GroupRepository {
  private readonly baseUrl = `${environment.apiUrl}/groupes`;

  constructor(private readonly http: HttpClient) { super(); }

  getByDispositifId(dispositifId: number): Observable<Group[]> {
    return this.http.get<GroupResponseDto[]>(this.baseUrl, { params: { dispositifId } }).pipe(
      map(dtos => dtos.map(dto => GroupMapper.fromDto(dto))),
    );
  }

  create(data: GroupCreateData): Observable<Group> {
    return this.http.post<GroupResponseDto>(this.baseUrl, GroupMapper.toRequestDto(data)).pipe(
      map(dto => GroupMapper.fromDto(dto)),
    );
  }

  update(id: number, data: GroupCreateData): Observable<Group> {
    return this.http.put<GroupResponseDto>(`${this.baseUrl}/${id}`, GroupMapper.toRequestDto(data)).pipe(
      map(dto => GroupMapper.fromDto(dto)),
    );
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${id}`);
  }
}
